export enum modalErrorTypes {
  Unavailable,
  Scheduled,
  Editadabox
}
